import productForm from './product-form';
import quickAdd from './quick-add';
import cartRecommendations from './cart-recommendations';
import audioPlayer from './audio-player';
import productLiveViewers from './product-live-viewers';

export default Alpine => {
  Alpine.data('productForm', productForm);
  Alpine.data('quickAdd', quickAdd);
  Alpine.data('cartRecommendations', cartRecommendations);
  Alpine.data('audioPlayer', audioPlayer);
  Alpine.data('productLiveViewers', productLiveViewers);
};
